export class CoverAvatarComponent {
    node!: any;
    uploadErrorMessage = 'Please upload photo smaller than 5 megabytes in size and use PNG, GIF or JPEG format.';

    _picture = '';
    _style = {};

    get style() {
        const url = this.$filter('thumb')(this.node.picture.source, 200, 200);
        // recreate the style object when avatar picture url changes
        if (url !== this._picture) {
            this._style = {
                backgroundImage: `url(${url})`,
            };
            this._picture = url;
        }

        return this._style;
    }

    constructor(protected $filter: ng.FilterFactory) {}
}

angular.module('tradersyard').component('tyCoverAvatar', {
    // language=HTML
    template: `
        <div class="cover_avatar">
            <div class="cover_avatar__picture" ng-style="$ctrl.style">

                <div ng-if="$ctrl.editable" class="cover_avatar__upload" onclick="document.getElementById('picture-input').click()">
                    <form name="form.picture" hidden>
                        <input name="picture"
                               id="picture-input"
                               type="file"
                               ng-model="picture"
                               flex-file64
                               flex-end="upload.picture($ctrl.node)"
                               flex-onerror="upload.error($ctrl.uploadErrorMessage)"
                               accept="$ctrl.acceptedUploadMimeTypes"
                               flex-maxsize="5242880"
                        >
                    </form>

                    <span class="icon-yard-add-image"></span>
                </div>
            </div>
        </div>
    `,
    controller: CoverAvatarComponent,
    bindings: {
        node: '<',
        editable: '<',
        uploadErrorMessage: '<',
        acceptedUploadMimeTypes: '@',
    },
});
